import { ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d994307"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "chanl-box"
};
const _hoisted_2 = {
  class: "chanl-left"
};
const _hoisted_3 = {
  class: "chanl-list-ul"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "chanl-right"
};
const _hoisted_6 = {
  class: "chanl-right-item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "回调地址:", -1));
const _hoisted_8 = {
  class: "chanl-right-item config-item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "配置方法:", -1));
import { getPayChnlList } from '@/api/payManage/domian';
import { copy } from '@/common';
import Empty from '@/components/Empty.vue';
import aliminigame from '@/assets/imgs/aliminigame.png';
import douyingame from '@/assets/imgs/douyinminigame.png';
import harmony from '@/assets/imgs/harmony.png';
import huawei_foreign from '@/assets/imgs/huawei_foreign.png';
import huawei_runtime_fastgame from '@/assets/imgs/huawei_runtime_fastgame.png';
import huawei from '@/assets/imgs/huawei.png';
import jsapipay from '@/assets/imgs/jsapipay.png';
import wxminigame from '@/assets/imgs/wxminigame.png';
export default /*#__PURE__*/_defineComponent({
  __name: 'DomainDrawer',
  props: {
    drawerVisible: {
      type: Boolean
    },
    columnItem: null
  },
  emits: ['update:drawerVisible', 'updateList'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const type = ref(''),
      search = ref(''),
      selectedIndex = ref(-1),
      selectedItem = ref({}),
      chanlList = ref([]),
      callbackUrl = ref('https://ewe8txd9jt.feishu.cn/wiki'),
      imgName = ref('');
    const handleCancel = () => {
      emit('update:drawerVisible', false);
    };
    const imgNameMap = {
      aliminigame,
      jsapipay,
      wxminigame,
      douyingame,
      harmony,
      huawei,
      huawei_foreign,
      huawei_runtime_fastgame
    };
    const handleItemClick = (item, index) => {
      selectedIndex.value = index;
      selectedItem.value = item;
      let url = '';
      if (item.dictDetailCode == 'huawei_foreign') {
        url = `${props.columnItem.overseasCallbackUrl}-${item.dictValue.callbackSuffix}`;
      } else {
        url = `${props.columnItem.inlandCallbackUrl}-${item.dictValue.callbackSuffix}`;
      }
      callbackUrl.value = ensureHttps(url);
      imgName.value = imgNameMap[item.dictDetailCode] || '';
    };
    const queryList = async val => {
      if (val === 'radio') {
        search.value = '';
      }
      let params = {
        dictDesc: search.value,
        dictCode: 'payChnl',
        pageNum: 1,
        pageSize: 1000,
        payFor: type.value
      };
      try {
        const {
          code,
          data
        } = await getPayChnlList(params);
        if (code === '0' && data.dictConfigs.length > 0) {
          chanlList.value = data.dictConfigs;
          // 默认展示第一个
          selectedIndex.value = 0;
          let url = '';
          if (data.dictConfigs[0].dictDetailCode == 'huawei_foreign') {
            url = `${props.columnItem.overseasCallbackUrl}-${data.dictConfigs[0].dictValue.callbackSuffix}`;
          } else {
            url = `${props.columnItem.inlandCallbackUrl}-${data.dictConfigs[0].dictValue.callbackSuffix}`;
          }
          callbackUrl.value = ensureHttps(url);
          imgName.value = imgNameMap[data.dictConfigs[0].dictDetailCode] || '';
        } else {
          chanlList.value = [];
          selectedIndex.value = -1;
          callbackUrl.value = '';
          imgName.value = '';
        }
      } catch (e) {}
    };
    const ensureHttps = url => {
      if (!url) return '';
      // 去除开头的 http:// 或 https://
      url = url.replace(/^(https?:\/\/)/i, '');
      return `https://${url}`;
    };
    // 控制弹窗展示
    watch(() => props.drawerVisible, val => {
      type.value = '';
      queryList();
    }, {
      immediate: true
    });
    expose({});
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_radio_button = _resolveComponent("a-radio-button");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createBlock(_component_a_drawer, {
        open: __props.drawerVisible,
        class: "custom-class",
        placement: "right",
        title: "查看渠道域名",
        closable: false,
        width: "756px",
        onClose: handleCancel
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_input, {
          value: search.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => search.value = $event),
          valueModifiers: {
            trim: true
          },
          allowClear: "",
          placeholder: "请输入渠道搜索名称",
          onKeyup: _cache[1] || (_cache[1] = _withKeys($event => queryList('keyup'), ["enter"]))
        }, null, 8, ["value"]), _createVNode(_component_a_radio_group, {
          class: "chanl-radio-group",
          value: type.value,
          "onUpdate:value": _cache[2] || (_cache[2] = $event => type.value = $event),
          "button-style": "solid",
          onChange: _cache[3] || (_cache[3] = $event => queryList('radio'))
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio_button, {
            value: ""
          }, {
            default: _withCtx(() => [_createTextVNode("全部")]),
            _: 1
          }), _createVNode(_component_a_radio_button, {
            value: "1"
          }, {
            default: _withCtx(() => [_createTextVNode("APP")]),
            _: 1
          }), _createVNode(_component_a_radio_button, {
            value: "2"
          }, {
            default: _withCtx(() => [_createTextVNode("小游戏")]),
            _: 1
          })]),
          _: 1
        }, 8, ["value"]), _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chanlList.value, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass({
              active: selectedIndex.value === index
            }),
            onClick: $event => handleItemClick(item, index)
          }, _toDisplayString(item.dictDesc), 11, _hoisted_4);
        }), 128))])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_textarea, {
          value: callbackUrl.value,
          "onUpdate:value": _cache[4] || (_cache[4] = $event => callbackUrl.value = $event),
          "auto-size": {
            minRows: 1,
            maxRows: 5
          },
          disabled: true
        }, null, 8, ["value"]), callbackUrl.value ? (_openBlock(), _createBlock(_component_SvgIcon, {
          key: 0,
          iconClass: "copy",
          class: "dbt-copyIcon",
          onClick: _cache[5] || (_cache[5] = $event => _unref(copy)(callbackUrl.value))
        })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", null, [imgName.value ? (_openBlock(), _createBlock(_component_a_image, {
          key: 0,
          width: 360,
          src: imgName.value
        }, null, 8, ["src"])) : (_openBlock(), _createBlock(Empty, {
          key: 1
        }))])])])])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});